<div class="header header2">
    <nav class="navbar navbar-default">
        <div class="navbar-header">
            <a class="navbar-brand" href="#"><img src="./assets/img/image-1.png" alt="logo"></a>
        </div>
    </nav>
</div>

<div class="bg_image boxs">
    <div class="box_fom boxs">
        <div style="height: auto !important;" class="form_bx boxs">
            <form (ngSubmit)="verify()" id="login-form">
                <h2>2-Step Authentication</h2>
                <div class="qrOb" #qrcodeDeposit id="qrcode-deposit">

                </div>
                <p class="varify-msg">
                    <strong>Step 1</strong>&nbsp; Download the <b>Google Authenticator</b> app and Sign in.
                    <br>
                    <strong>Step 2</strong>&nbsp;Enter the verification code generated.
                </p>
                <!-- <label style="color: rgb(95, 219, 170);" class="resendMessage">OTP sent
                    successfully.</label> -->
                <label class="error-custom">{{errorMsg}}</label>
                <div class="form-group">
                    <label>Enter 2-step verification code: </label>

                    <input type="text" name="verificationCode" [(ngModel)]="authy.verificationCode"
                        class="form-control text-center" [disabled]="loading" placeholder="Enter code" maxlength="6"
                        autocomplete="off"
                        onkeyup="if(this.value.length==6){$('.hvr-sweep-to-right').removeAttr('disabled')};"
                        onkeypress="return (event.charCode>=48 && event.charCode<=57) || event.charCode == 8 || event.charCode == 13">
                </div>
                <div class="sign_btn boxs">
                    <button  type="button" class="hvr-sweep-to-right vr-wrong"><img
                            src="./assets/img/loading.gif" />
                        Loading</button>
                    <button  [disabled]="!authy.verificationCode || authy.verificationCode.length < 6"
                        type="submit" class="hvr-sweep-to-right vr-right " style="display: none;">VERIFY</button>
                </div>
                <div align="center">
                    <label class="error-login">{{authError}}</label>
                </div>
            </form>
        </div>
    </div>
</div>